import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { MultiSelectComponent, FieldSettingsModel, MultiSelectChangeEventArgs, Inject as DropdownInject, CheckBoxSelection } from '@syncfusion/ej2-react-dropdowns';
import DateRange from '../../../components/filters/dateRange';

import { ITrackingsListFilterProps } from '../../../interfaces/props/ITrackingsListProps';
import TextBox from '../../../components/filters/textBox';
import { IStringToAnyDictionary } from '../../../common/model/stringToAnyDictionary.model';

type TrackingsListFilterPropsType = ITrackingsListFilterProps & WithTranslation;

class TrackingListFilter extends Component<TrackingsListFilterPropsType> {
  public optionsFields: FieldSettingsModel = { text: 'name', value: 'id' };

  public constructor(props: TrackingsListFilterPropsType) {
    super(props);
  }

  public onSeasonCodesChange(e: MultiSelectChangeEventArgs) {
    const codes = e.value as string[];
    this.props.onSeasonCodesChange(codes);
  }

  public onOfficeCodesChange(e: MultiSelectChangeEventArgs) {
    const codes = e.value as string[];
    this.props.onOfficeCodesChange(codes);
  }

  public shouldShowClientFilter(): boolean {
    return this.props.isCurrentUserInternal || this.props.hasCurrentUserChain;
  }

  public render() {
    const {
      filter,
      isFetching,
      onReportNumberChange,
      onVersionChange,
      onSelectionNumberChange,
      onModelChange,
      onReferenceChange,
      onShipmentDateChange,
      seasonOptions,
      officeOptions,

      onFilterButtonClick,
      i18n
    } = this.props;

    return (
      <form onSubmit={(e: React.FormEvent) => { e.preventDefault(); onFilterButtonClick(); }}>
        <div className='row'>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('trackingsList.reportNumber')}</div>
                <TextBox
                  name='reportNumber'
                  value={filter.reportNumber}
                  showClearButton={true}
                  onChange={(value) => onReportNumberChange(value)}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('trackingsList.version')}</div>
                <TextBox
                  name='version'
                  value={filter.version}
                  showClearButton={true}
                  onChange={(value) => onVersionChange(value)}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('trackingsList.season')}</div>
                <MultiSelectComponent
                  query={null} /* query will be set dynamically */
                  dataSource={seasonOptions as IStringToAnyDictionary[]}
                  fields={this.optionsFields}
                  sortOrder='Ascending'
                  mode='CheckBox'
                  showDropDownIcon={true}
                  allowFiltering={true}
                  filterType='Contains'
                  change={(e: MultiSelectChangeEventArgs): void => this.onSeasonCodesChange(e)}
                  showClearButton={true}
                >
                  <DropdownInject services={[CheckBoxSelection]} />
                </MultiSelectComponent>
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('trackingsList.selectionNumber')}</div>
                <TextBox
                  name='selectionNumber'
                  value={filter.selectionNumber}
                  showClearButton={true}
                  onChange={(value) => onSelectionNumberChange(value)}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('trackingsList.model')}</div>
                <TextBox
                  name='model'
                  value={filter.model}
                  showClearButton={true}
                  onChange={(value) => onModelChange(value)}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('trackingsList.reference')}</div>
                <TextBox
                  name='reference'
                  value={filter.reference}
                  showClearButton={true}
                  onChange={(value) => onReferenceChange(value)}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('trackingsList.office')}</div>
                <MultiSelectComponent
                  query={null} /* query will be set dynamically */
                  dataSource={officeOptions as IStringToAnyDictionary[]}
                  fields={this.optionsFields}
                  sortOrder='Ascending'
                  mode='CheckBox'
                  showDropDownIcon={true}
                  allowFiltering={true}
                  filterType='Contains'
                  change={(e: MultiSelectChangeEventArgs): void => this.onOfficeCodesChange(e)}
                  showClearButton={true}
                >
                  <DropdownInject services={[CheckBoxSelection]} />
                </MultiSelectComponent>
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <DateRange
                name={i18n.t('trackingsList.shipmentDate')}
                value={filter.shipmentDate}
                i18n={i18n}
                onChangeInput={(value) => onShipmentDateChange(value)}
              />
            </div>
          </div>
        </div>
        <div className='row justify-content-end'>
          <div className='col-auto'>
            <button type='submit' className='btn btn-secondary' title={i18n.t('actions.filter')} disabled={isFetching}>
              {isFetching ?
                <span className='spinner-border spinner-border-sm' />
                :
                <span className='icon icon-app-item-search' />
              }
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default withTranslation()(TrackingListFilter);
